import {useMutation} from '@apollo/react-hooks';

import type {
    MeetingUpdateInput,
    UpdateMeeting as UpdateMeetingMutation,
    UpdateMeetingVariables as UpdateMeetingMutationVariables,
} from 'nutshell-graphql-types';

import {nutApolloClient} from '../../../../apollo-client';

import MEETING_FRAGMENT from '../fragments/meeting-fragment.graphql';
import UPDATE_MEETING from '../mutations/update-meeting.graphql';

export function useUpdateMeeting(): (arg1: MeetingUpdateInput) => Promise<any> {
    const [updateMeeting] = useMutation<UpdateMeetingMutation, UpdateMeetingMutationVariables>(
        UPDATE_MEETING
    );

    return (input: MeetingUpdateInput) => {
        const meeting = nutApolloClient.readFragment({
            id: input.id,
            fragment: MEETING_FRAGMENT,
            fragmentName: 'MeetingFragment',
        });

        return updateMeeting({
            variables: {input},
            optimisticResponse: meeting
                ? {
                      // @ts-expect-error
                      __typename: 'Mutation',
                      meetingUpdate: {
                          __typename: 'MeetingUpdatePayload',
                          meeting: {
                              ...meeting,
                              isActive: input.isActive,
                              isHidden: input.isHidden,
                          },
                      },
                  }
                : undefined,
            update: (proxy, mutationResults) => {
                const updatedMeeting =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.meetingUpdate &&
                    mutationResults.data.meetingUpdate.meeting;

                if (!updatedMeeting) return;

                proxy.writeFragment({
                    id: input.id,
                    fragment: MEETING_FRAGMENT,
                    fragmentName: 'MeetingFragment',
                    data: {
                        ...updatedMeeting,
                    },
                });
            },
        });
    };
}
